<template>
  <div class="container" @click="goToHome">
    <div
      class="content pop"
      :style="{ animationDelay: `0s`, animationDuration: `0.2s` }"
    >
      <img key="logo" class="gelatine" src="@/../public/img/HEI.png" />
    </div>
    <div class="footer">
      Made by Des Choses Pareilles - Version {{ $store.state.packageVersion }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  beforeUnmount() {},
  methods: {
    goToHome() {
      // Determine the current language from localStorage or default to 'fr' and store it
      var currentLang = "fr";
      if (localStorage.getItem("selectedLang")) {
        currentLang = localStorage.getItem("selectedLang");
      } else {
        localStorage.setItem("selectedLang", currentLang);
      }
      this.$router.push({
        name: "home",
        params: { lang: currentLang },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background: $primary-color;
}

p {
  font-size: 4em;
}

img {
  max-width: 40vw;
  max-height: 40vh;
}

.breathe {
  animation: breathe 8s ease-in-out infinite;
}

@keyframes breathe {
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(1.2);
  }
  40% {
    transform: scale(1);
  }
  100% {
    transform: scale(1);
  }
}

.pop {
  transform: scale(0);
  animation-name: pop-scale;
  animation-fill-mode: forwards;
  transition: background-color 0.3s ease;
}

/* Animation de pop */
@keyframes pop-scale {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.gelatine {
  animation: gelatine 5s infinite;
}

@keyframes gelatine {
  from,
  to {
    transform: scale(1, 1);
  }
  90% {
    transform: scale(1, 1);
  }
  92.5% {
    transform: scale(0.9, 1.1);
  }
  95% {
    transform: scale(1.1, 0.9);
  }
  97.5% {
    transform: scale(0.95, 1.05);
  }
  100% {
    transform: scale(1, 1);
  }
}
</style>
